import { Injectable } from '@angular/core';
import DomainEventProvider from 'src/app/core/domain/events/domain_event_provider';

import { NotificationEvent } from './notification_events';

@Injectable({ providedIn: 'root' })
export class NotificationEventProvider extends DomainEventProvider<NotificationEvent> {}
